import { Directive, ElementRef, Input, HostListener, Output, EventEmitter } from '@angular/core';
import { OccurencesComponent } from '@app/occurences/occurences.component';
import { AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appCpfCnpj]'
})
export class CpfCnpjDirective {

  @Output() 
  onPressEnter: EventEmitter<any> = new EventEmitter();

  element:any;

  arrayNumber:any[] = ['0','1','2','3','4','5','6','7','8','9'];
  arrayFunction:any[] = ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown']

  component : OccurencesComponent;

  constructor(private el: ElementRef, component: OccurencesComponent) {
    this.component = component;;
  }

  ngAfterViewInit(){
    this.element = this.el.nativeElement;
  }

  @HostListener('keyup', ['$event']) onKeyUp(event: KeyboardEvent) {
    if (event.key == 'Enter') {
      this.onPressEnter.emit();
    } else if (this.arrayFunction.indexOf(event.key) < 0) {
      this.element.value = this.convertToCpfCnpj(this.element.value);
      if(this.component.filterForm){
        this.component.filterForm.get('fCpfCnpj').setValue(this.element.value);
        this.component.filterForm.get('fCpfCnpj').markAsDirty();
      }
    }
  }

  convertToCpfCnpj(num) {
    if (num) {
      num = num.toString();
      num = num.replace(/\D/g, '');
      
      if (num.length > 0 && num.length <= 14) {
        num = this.refreshValue(num);
      } else {
        num = this.refreshValue(num.slice(0,14));
      }
    }
    return num;
  }

  refreshValue(val: string): string {
    let returnValue = '';
    switch (val.length) {
      case 4:
        returnValue = val.replace(/(\d+)(\d{3})/, " $1.$2");
        break;
      case 5:
        returnValue = val.replace(/(\d+)(\d{3})/, " $1.$2");
        break;
      case 6:
        returnValue = val.replace(/(\d+)(\d{3})/, " $1.$2");
        break;
      case 7:
        returnValue = val.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
        break;
      case 8:
        returnValue = val.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
        break;
      case 9:
        returnValue = val.replace(/(\d+)(\d{3})(\d{3})/, " $1.$2.$3");
        break;
      case 10:
        returnValue = val.replace(/(\d+)(\d{3})(\d{3})(\d{1})/, " $1.$2.$3-$4");
        break;
      case 11:
        returnValue = val.replace(/(\d+)(\d{3})(\d{3})(\d{2})/, " $1.$2.$3-$4");
        break;
      case 12:
        returnValue = val.replace(/(\d+)(\d{3})(\d{3})(\d{4})/, " $1.$2.$3/$4");
        break;
      case 13:
        returnValue = val.replace(/(\d+)(\d{3})(\d{3})(\d{4})(\d{2})/, " $1.$2.$3/$4-$5");
        break;
      case 14:
        returnValue = val.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d+)/, " $1.$2.$3/$4-$5");
        break;
      default:
        returnValue = val;
        break;
    }
    return returnValue.trim();
  }
}
